module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/graduate.8a537203.svg";